/** @format */

import {ShowCondition, WidgetSettings, WidgetStat} from '../model';

interface Options {
  showCondition: ShowCondition;
  widgetSettings?: WidgetSettings;
}

const getWidgetStatsData = ({showCondition, widgetSettings}: Options): WidgetStat[] => {
  return (
    widgetSettings?.stats?.filter(stat => {
      if (!stat.showConditions || showCondition === 'all') {
        return true;
      }
      if (stat.showConditions.includes('all')) {
        return true;
      }

      return stat.showConditions.includes(showCondition);
    }) || []
  );
};

export default getWidgetStatsData;
